import { model as i18n } from '!/i18n'
import {
  api,
  type GetPartnerProductsByPageParams,
  type Page,
  type PageableInfoNew,
  type PartnerProduct,
} from '@setplex/tria-api'
import { combine, createEvent, createStore, sample } from 'effector'
import { not } from 'patronum'
import { genPagesLogicNew } from '~/shared/effector'
import { formatPartnerProductItem } from '../helpers'
import type { PartnerProductGrid } from '../index.h'

export const resetPartnerProductGrid = createEvent()
const partnerProductGridLoaded = createEvent<Page<PartnerProduct>>()

export const $partnerProductGrid = createStore<PartnerProductGrid | null>(null)
  .on(partnerProductGridLoaded, (state, page) => {
    const currentPartnerProducts = state
      ? [...state.content, ...page.content]
      : page.content

    return {
      ...page,
      content: currentPartnerProducts,
    }
  })
  .reset(resetPartnerProductGrid)

export const $partnerProductGridFormatted = combine(
  $partnerProductGrid,
  i18n.$t,
  (partnerProductGrid) => {
    const formattedPageContent = partnerProductGrid?.content.map(
      formatPartnerProductItem
    )

    return {
      ...partnerProductGrid,
      content: formattedPageContent,
    }
  }
)

export const $partnerProductGridLoading = combine(
  api.partnerProgram.getPartnerProductsByPageGridFx.pending,
  $partnerProductGrid,
  (partnerProductsByPageGridLoading, partnerProductGrid) =>
    partnerProductsByPageGridLoading && !partnerProductGrid
)

export const loadPartnerProductGrid =
  createEvent<GetPartnerProductsByPageParams>()

sample({
  clock: loadPartnerProductGrid,
  target: api.partnerProgram.getPartnerProductsByPageGridFx,
})

sample({
  clock: api.partnerProgram.getPartnerProductsByPageGridFx.doneData,
  target: partnerProductGridLoaded,
})

export const loadMorePartnerProductGrid = createEvent()
export const loadMorePartnerProductGridByPage = genPagesLogicNew(
  $partnerProductGrid.map((state) => {
    if (!state) return null

    const { last, first, number, size } = state
    const pageableInfo: PageableInfoNew = {
      last,
      first,
      number,
      size,
    }
    return pageableInfo
  }),
  api.partnerProgram.getPartnerProductsByPageGridFx
)

sample({
  clock: loadMorePartnerProductGrid,
  filter: not($partnerProductGridLoading),
  fn: () => ({}),
  target: loadMorePartnerProductGridByPage,
})
